export default __webpack_public_path__ + "static/media/avatar_tommy8.24167d56.mp3";